import clsx from 'clsx'
import { Icon } from '@iconify/react'

import StatCard from '../../StatCard/StatCard'
import StatProgress from '../StatProgress/StatProgress'

import { Stat } from '../../types'

import s from './StatBtn.module.css'
import { Tooltip } from '@pepper/ui'

type Props = Stat & {
  isActive: boolean
  onClick: () => void
}

const StatBtn = ({
  isActive,
  onClick,
  title,
  value,
  change,
  progressChange,
  progressPercent,
  progressTitle,
  progressValue,
  tooltip,
}: Props) => {
  return (
    <button
      onClick={onClick}
      className={clsx(s.wrapper, {
        [s.active]: isActive,
      })}
    >
      <div className={s.top}>
        <StatCard
          title={title}
          value={value}
          change={change}
          isActive={isActive}
          showDot={true}
        />
        <Tooltip title={tooltip} placement="bottomLeft">
          <Icon icon="lucide-info" width={16} height={16} />
        </Tooltip>
      </div>
      <StatProgress
        title={progressTitle}
        value={progressValue}
        change={progressChange}
        percent={progressPercent}
        isActive={isActive}
      />
    </button>
  )
}

export default StatBtn
